import { axiosClient } from '../../../../utils/axiosClient';
import { makeApiRequest, type ApiResponse } from '../../../utils';
import { HomeEndpoints } from './homeEndpoints';
import type { GetDoneeResponse } from './response';

export class HomeService {
    public async getDonee(
        id: string,
        clientAccessToken: string,
    ): Promise<ApiResponse<GetDoneeResponse>> {
        const url = HomeEndpoints.getDonee(id);
        const httpRequest = axiosClient.get(url, {
            headers: {
                clientAccessToken: clientAccessToken
                    ? `Bearer ${clientAccessToken}`
                    : undefined,
            },
        });
        return makeApiRequest<GetDoneeResponse>(httpRequest);
    }
}
